import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { businessTimeZone } from "../../utils/date"
import { normalizeError } from "../../utils/errorHelpers"

export const getTaskPeopleReq = createAsyncThunk('tasks/getTaskPeopleReq', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/tasks/users/${userId}/people`)
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error), { status: error.response?.status })
  }
})

export const createTaskReq = createAsyncThunk('tasks/createTaskReq', async (data, { rejectWithValue }) => {
  try {
    const { userId } = data
    const response = await apiRequest.post(`/tasks/users/${userId}`, data)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create task'
    return rejectWithValue(errorMessage)
  }
})

export const getAllTasksReq = createAsyncThunk('tasks/getAllTasksReq', async ({ userId, limit,
  offset,
  searchQuery,
  filters }, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/tasks/users/${userId}`, {
      params: {
        limit,
        offset,
        searchQuery,
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get all tasks'
    return rejectWithValue(errorMessage)
  }
})

export const getAllTasksPageReq = createAsyncThunk('tasks/getAllTasksPageReq', async ({ limit,
  offset,
  searchQuery,
  filters }, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/tasks-all`, {
      params: {
        limit,
        offset,
        searchQuery,
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get all tasks'
    return rejectWithValue(errorMessage)
  }
})

export const getTaskStatuses = createAsyncThunk('tasks/getTaskStatuses', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/tasks-statuses/dropdown/info`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const updateTaskReq = createAsyncThunk('tasks/updateTaskReq', async ({ taskId, data }, { rejectWithValue }) => {
  try {
    console.log(data);

    const response = await apiRequest.put(`/tasks/${taskId}`, data)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getTaskByIdReq = createAsyncThunk('tasks/getTaskByIdReq', async (taskId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/tasks/${taskId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const deleteTaskByIdReq = createAsyncThunk('tasks/deleteTaskByIdReq', async (taskId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/tasks/${taskId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getTaskTemplatesReq = createAsyncThunk('tasks/getTaskTemplatesReq', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/tasks-template`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getTasksForFilterUtils = createAsyncThunk('tasks/getTasksForFilterUtils', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/tasks/filters/utils')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch tasks filter utils'
    return rejectWithValue(errorMessage)
  }
})

export const getTaskStatusesDropdown = createAsyncThunk('tasks/getTaskStatusesDropdown', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/tasks-statuses/dropdown/info')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch task statuses dropdown'
    return rejectWithValue(errorMessage)
  }
})

export const getTaskStatusesForFilterUtils = createAsyncThunk('tasks/getTaskStatusesForFilterUtils', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/tasks-statuses/filters/utils')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch task statuses filter utils'
    return rejectWithValue(errorMessage)
  }
})
